import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BasemapDescriptor, VectorLayerDescriptor } from 'map-wald-leaflet';
import { ConfigService } from '../config.service';
import { DisplaySettingsChange } from '../data';

@Component({
  selector: 'app-display-settings',
  templateUrl: './display-settings.component.html',
  styleUrls: ['./display-settings.component.scss']
})
export class DisplaySettingsComponent implements OnInit {
  @Input() opacity: number;
  @Input() vectorLayer:VectorLayerDescriptor;
  @Input() basemap: BasemapDescriptor;
  @Input() zoom:number;
  @Input() showLegend:boolean;
  @Input() showScale:boolean;

  @Output() displaySettingsChange = new EventEmitter<DisplaySettingsChange>();

  basemaps: BasemapDescriptor[];
  vectorLayers:VectorLayerDescriptor[];

  constructor(private appConfig:ConfigService) {
  }

  ngOnInit(): void {
    this.appConfig.basemaps$.subscribe(basemaps=>{
      this.basemaps = basemaps;
      this.basemap = this.basemap || basemaps[0];
    });

    this.appConfig.vectorLayers$.subscribe(vectors=>{
      this.vectorLayers = vectors;
      this.vectorLayer = this.vectorLayer || vectors[0];
    });
  }

  settingControlChanged(event: DisplaySettingsChange) {
    this.displaySettingsChange.emit(event);
  }

  basemapChanged():void{
    this.displaySettingsChange.emit({
      setting: 'basemap',
      value: this.basemap
    });
  }

  vectorLayerChanged(event:VectorLayerDescriptor): void {
    this.vectorLayer = event;
    this.displaySettingsChange.emit({
      setting:'vectorLayer',
      value:this.vectorLayer
    });
  }

  showScaleChanged() {
    this.displaySettingsChange.emit({
      setting:'showScale',
      value:this.showScale
    });
  }
  showLegendChanged() {
    this.displaySettingsChange.emit({
      setting:'showLegend',
      value:this.showLegend
    });
  }
  closePanel() {
    this.displaySettingsChange.emit({
      setting:'closePanel',
      value:null
    });
  }
}

